/**
 * La rubrique d'un attendu, en couleur (2026-09-29, demande du prof) : les
 * objectifs d'apprentissage en bleu TanoEd, les automatismes en teal (la
 * couleur des automatismes dans les groupes). L'orange reste au badge
 * « proposition », le vert aux réussites : rien ne se confond sur une ligne.
 * Rubrique absente = objectif (défaut du back).
 *
 * Seul l'AUTOMATISME porte une pastille : une « Objectif » répétée sur chaque
 * ligne faisait du bruit (revue du 2026-09-29) ; une ligne sans pastille est
 * un objectif. Dans un chapitre, les deux intertitres gardent leur couleur.
 */
export const RUBRIQUES = {
    objectif: {
        libelle: 'Objectif',
        titre: 'Objectifs d\'apprentissage',
        pastille: 'bg-blue-100 text-blue-800',
        intertitre: 'text-blue-700',
    },
    automatisme: {
        libelle: 'Automatisme',
        titre: 'Automatismes',
        pastille: 'bg-teal-100 text-teal-800',
        intertitre: 'text-teal-700',
    },
};

/** 'automatisme' ou 'objectif' (défaut) pour un attendu. */
export const rubriqueDe = (attendu) => (attendu?.rubrique === 'automatisme' ? 'automatisme' : 'objectif');

const PastilleRubrique = ({ attendu }) => {
    if (rubriqueDe(attendu) !== 'automatisme') return null;
    const r = RUBRIQUES.automatisme;
    return (
        <span className={`flex-shrink-0 text-[10.5px] font-extrabold rounded-full px-2 py-0.5 ${r.pastille}`}>
            {r.libelle}
        </span>
    );
};

export default PastilleRubrique;
